/** @jsxImportSource @emotion/react */
import React from 'react';
import PageTemplate from '@page/admin/page-template';
import VocabularyBookHome from '@component/admin/vocabulary-book/vocabulary-book-home';

const VocabularyBookListPage: React.FC = () => {
  return (
    <PageTemplate title='단어집 관리'>
      <VocabularyBookHome />
    </PageTemplate>
  );
};

export default VocabularyBookListPage;
